import React from 'react'
import { GuestContent } from '../event-detail/components'
import { DefaultLayout } from '../../layouts'
import { Container, SimplePageHeader } from '../../components'
import { MobileViewportProvider } from '../../utils'

const EventRegister = () => {
  return (
    <DefaultLayout>
      <SimplePageHeader noPadding />
      <MobileViewportProvider>
        <hr className="mt-1 mb-5"/>
      </MobileViewportProvider>
      <Container>
        <GuestContent />
      </Container>
    </DefaultLayout>
  )
}

export { EventRegister }